<template>
  <GuestCard />
</template>

<script>
import { mapActions } from 'vuex'

import GuestCard from '@/components/SaleDetail/GuestCard'

export default {
  name: 'GuestSale',
  components: {
    GuestCard
  },
  async beforeMount () {
    const saleId = this.$route.params.id
    const secureToken = this.$route.query.secure_token

    await this.['guestSaleDetail/getSale'](saleId)
    this.['guestSaleDetail/setSecureToken'](secureToken)
  },
  destroyed () {
    this.clearSaleDetailState()
  },
  methods: {
    ...mapActions([
      'guestSaleDetail/getSale',
      'guestSaleDetail/setSecureToken'
    ]),
    ...mapActions('guestSaleDetail', [
      'clearSaleDetailState'
    ])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#guest-sale {
  color: $grey;
  text-align: start;
  margin: rem 2rem;
}

.title {
  text-align: start;
  color: $grey;
}

.link {
  color: $blue;
  text-decoration: none;
  font-style: italic;
}

.card {
  border-radius: 25px;
  background-color: $white;
}

.card-section {
  padding: 1.25rem 2rem;
}

.vehicle-information {
  width: 25%;
}

.center-text {
  text-align: center;
}

.btn {
  font-size: 0.75rem;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  border: 1px solid $light-blue;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.accept {
    color: $white;
    margin-left: 1rem;
    background-color: $light-blue;
  }

  &.cancel {
    margin-right: 1rem;
    color: $light-blue;
    background-color: $white;
  }
}

hr {
  border: 1px solid $grey;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  margin-inline-start: 0;
  margin-inline-end: 0;
}

@media screen and (max-width: 60rem) {
  .link {
    display: none;
  }

  .card {
    width: 100%;
  }

  .vehicle-information {
    width: auto;
  }

  .btn {
    &.accept {
      margin-left: 0;
    }

    &.cancel {
      margin-right: 0;
    }
  }

  h2 {
    font-size: 1.25rem;
  }

  hr {
    margin-block-start: 0rem;
    margin-block-end: 0rem;
    margin-inline-start: 1.25rem;
    margin-inline-end: 1.25rem;
  }
}
</style>
